module.exports = __webpack_public_path__ + "static/media/wa.5b9ad16b.png";